import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { isAuthenticated, isLoading, isAdmin, hasProductAccess } = useAuth();

  if (isLoading) {
    return (
      <div style={styles.container}>
        <div style={styles.loader}>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!adminOnly && !hasProductAccess()) {
    return <Navigate to="/login?access_unavailable=1" replace />;
  }

  if (adminOnly && !isAdmin()) {
    return (
      <div style={styles.container}>
        <div style={styles.errorCard}>
          <h2 style={styles.errorTitle}>Access Denied</h2>
          <p style={styles.errorText}>
            You don't have permission to access this page.
          </p>
        </div>
      </div>
    );
  }

  return children;
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f9fc',
  },
  loader: {
    color: '#102a43',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  errorCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '16px',
    padding: '40px',
    maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  errorTitle: {
    color: '#c33',
    marginBottom: '16px',
  },
  errorText: {
    color: '#666',
  },
};

export default ProtectedRoute;
